<div class="confirm-account-wrapper">
  <img role="presentation" src="assets/images/illustrations/light-beige.svg" class="background-image" />
  <div class="recovery-card" style="-webkit-overflow-scrolling: touch">
    <div class="right">
      <a class="arrow-back" (click)="handleBack()">
        <svg width="24" height="10" viewBox="0 0 24 10" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M5.59998 9.00006L1.59998 5.00006L5.59998 1.00006M1.59998 5.00006H22.4H1.59998Z"
            stroke="#333333"
            stroke-width="2"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </a>
      <div class="content">
        <div>
          <p class="title">Code Sent</p>
          <p class="info">
            If you didn't get a code, press “Re-send Verification Code” again. If the problem persists, please contact
            support.
          </p>

          <form [formGroup]="form">
            <div class="form-container">
              <!-- - - - - - - - - - - - - - NEW AUTH - - - - - - - - - - - - -->
              <sign-in-flag-input
                (inputEvent)="confirmAccountEvent($event)"
                [confirmAccount]="true"
              ></sign-in-flag-input>

              @if (getVerificationCode?.errors && getVerificationCode?.dirty) {
                <div class="errors-area">
                  @if (getVerificationCode?.hasError('sendCode')) {
                    <p>Unable to resend verification code</p>
                  }
                </div>
              }

              <button mat-raised-button class="app-button" (click)="onResend()">Re-send Verification Code</button>
            </div>

            <!-- - - - - - - - - - - - - - CONFIRMATION CODE - - - - - - - - - - - - -->
            <div class="form-container">
              <mat-form-field>
                <input matInput placeholder="CONFIRMATION CODE" formControlName="verificationCode" autocomplete="off" />
              </mat-form-field>

              @if (getVerificationCode?.errors && getVerificationCode?.dirty) {
                <div class="errors-area">
                  @if (getVerificationCode?.hasError('minlength')) {
                    <p>A 6 Digits Verification Code Required</p>
                  }
                  @if (getVerificationCode?.hasError('validation')) {
                    <p>Wrong Verification code</p>
                  }
                </div>
              }

              <button mat-raised-button class="app-button" (click)="onConfirm()" [disabled]="form?.invalid">
                Continue to Scoot
              </button>
            </div>
          </form>

          @if (successSignUp) {
            <div id="successThankYou" class="thanks-message">
              <div class="navigation">
                <a href="/"><mat-icon>arrow_back</mat-icon></a>
              </div>
              <div class="content">
                <div class="subheader">
                  <h3>Success!</h3>
                  <p>Thank you for signing up</p>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>
